
import React, { useEffect } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { StatsSection } from './components/StatsSection';
import { QuoteForm } from './components/QuoteForm';
import { ContactSection } from './components/ContactSection';

const HomePage: React.FC = () => {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Özgür Osgb';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Selçuklu Konya merkezli Özgür OSGB, Sancak Mahallesi\'nde hizmet veren İş Sağlığı ve Güvenliği uzmanı. İşyerlerinde güvenli çalışma ortamı için kapsamlı İSG hizmetleri, risk analizi ve eğitimler.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Selçuklu İş Sağlığı, Konya İş Güvenliği, OSGB, İSG Eğitimi, Risk Analizi');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://ozgurisg.net'}`);
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <header>
          <h1 style={{ position: 'absolute', left: '-9999px' }}>Özgür Osgb - İş Sağlığı ve Güvenliği</h1>
        </header>
        <HeroSection />
        <ServicesSection />
        <StatsSection />
        <QuoteForm />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;